import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { AlertTriangle, Loader2 } from "lucide-react";
import { renderBriefBody } from "./briefBody";

// Release 0.1 core — public Executive Brief view.
// Read-only. Watermarked. No login. Served by GET /api/public/brief/:token.
const BASE = process.env.REACT_APP_BACKEND_URL;

export default function PublicBrief() {
  const { token } = useParams();
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    document.title = "Executive Opportunity Brief · BidNoBidIQ";
    axios.get(`${BASE}/api/public/brief/${token}`)
      .then((r) => setDoc(r.data))
      .catch((e) => setErr(e?.response?.status === 410 ? "This share link is no longer active." : "Brief not found."));
  }, [token]);

  if (err) return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6" data-testid="public-brief-error">
      <div className="max-w-md text-center">
        <div className="w-12 h-12 rounded-full bg-rose-100 mx-auto mb-4 flex items-center justify-center">
          <AlertTriangle className="w-5 h-5 text-rose-600" />
        </div>
        <h1 className="font-display font-bold text-slate-900 text-xl mb-2">Unable to open brief</h1>
        <p className="text-slate-600 text-sm">{err}</p>
        <Link to="/" className="mt-6 inline-block font-mono text-[11px] tracking-widest uppercase text-sky-700">← BidNoBidIQ home</Link>
      </div>
    </div>
  );
  if (!doc) return <div className="min-h-screen bg-white flex items-center justify-center"><Loader2 className="w-4 h-4 animate-spin text-slate-500" /></div>;

  return (
    <div className="min-h-screen bg-slate-100 py-8 print:bg-white print:py-0" data-testid="public-brief">
      <div className="max-w-[900px] mx-auto px-4">
        <div className="text-right mb-3 print:hidden">
          <button onClick={() => window.print()} data-testid="public-brief-print"
            className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-mono text-[11px] tracking-[0.2em] uppercase font-bold px-4 py-2.5">
            Print / Save PDF
          </button>
        </div>

        {/* Printable body — same layout as authenticated brief but with watermark */}
        <div id="brief-print-root" className="relative bg-white shadow-xl p-10 print:shadow-none print:p-6">
          {/* Watermark (repeated diagonal) — visible in browser AND in print */}
          <div className="pointer-events-none absolute inset-0 overflow-hidden select-none" aria-hidden="true">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="rotate-[-30deg] text-slate-200 font-display font-black text-5xl tracking-widest opacity-60 print:opacity-40" data-testid="public-brief-watermark">
                Prepared by BidNoBidIQ
              </div>
            </div>
          </div>
          {renderBriefBody(doc, { publicMode: true })}
        </div>
      </div>

      <style>{`
        @media print {
          @page { size: Letter; margin: 0.5in; }
          html, body { background: #ffffff !important; }
          body * { visibility: hidden !important; }
          #brief-print-root, #brief-print-root * { visibility: visible !important; }
          #brief-print-root { position: absolute; left: 0; top: 0; width: 100%; box-shadow: none !important; padding: 0 !important; }
        }
      `}</style>
    </div>
  );
}
